// HoldingsRow.js
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './HoldingsRow.css';
import ReactTooltip from 'react-tooltip';

class HoldingsRow extends Component {
  /* ------------------------------- utilities ------------------------------ */

  // 0.023 -> "2.30%"
  formatPercent(n) {
    const v = Number(n);
    return Number.isFinite(v) ? `${(v * 100).toFixed(2)}%` : '-';
  }

  // Match TopHoldings’ cleanup
  cleanName(name = '') {
    return name.split('|').pop().replace('&amp;', '&').trim();
  }

  toKey(name = '') {
    return this.cleanName(name).toLowerCase();
  }

  /**
   * Build tooltip HTML using presenceMap (built from FULL holdings in TopHoldings).
   * presenceMap[key] = [{ ticker, weight }]
   */
  getTipFromPresenceMap(holding) {
    const { presenceMap } = this.props;
    if (!holding) return '';

    const label = this.cleanName(holding.name);
    const key = this.toKey(holding.name);

    const entries = (presenceMap && presenceMap[key]) || [];
    if (!entries.length) {
      // Not found elsewhere — show at least the label
      return `<strong>${label}</strong>`;
    }

    // Optional: stable sort by ticker
    const sorted = entries
      .slice()
      .sort((a, b) => a.ticker.localeCompare(b.ticker));

    const lines = sorted
      .map(({ ticker, weight }) => `${ticker}: ${this.formatPercent(weight)}`)
      .join('<br/>');

    return `<strong>${label}</strong><br/>${lines}`;
  }

  /* --------------------------------- render -------------------------------- */

  render() {
    const { fundRows, idx, type, x } = this.props;

    // Render one logical row across all fund columns (name + weight cells)
    const buildRow = (rowIdx) =>
      fundRows.map((colList, colIdx) => {
        const hasRow = Array.isArray(colList) && colList.length > rowIdx;

        if (!hasRow) {
          return (
            <Fragment key={`${rowIdx}-${colIdx}`}>
              <td className="textLeft"></td>
              <td className="textLeft"></td>
            </Fragment>
          );
        }

        const holding = colList[rowIdx];
        const label = this.cleanName(holding?.name);
        const weight = this.formatPercent(holding?.weight);
        const tipId = `holdings-${rowIdx}-${colIdx}`; // shared by name and weight cell

        return (
          <Fragment key={`${rowIdx}-${colIdx}`}>
            {/* Holding name (tooltip lives here) */}
            <td className="textLeft" data-tip data-for={tipId}>
              {label || '—'}
              <ReactTooltip
                id={tipId}
                type="light"
                className="holdingstip"
                effect="float"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.getTipFromPresenceMap(holding),
                  }}
                />
              </ReactTooltip>
            </td>

            {/* Weight (references same tooltip id) */}
            <td className="textCenter" data-tip data-for={tipId}>
              {weight}
            </td>
          </Fragment>
        );
      });

    // Subtotal row (sum first 10 visible entries per fund)
    const buildSubtotal = () =>
      fundRows.map((colList, colIdx) => {
        const firstTen = (colList || []).slice(0, 10);
        const subtotalRaw = firstTen.reduce(
          (acc, h) => acc + (Number(h?.weight) || 0),
          0
        );

        return (
          <Fragment key={`subtotal-${colIdx}`}>
            <td
              className={`subTotalTextLeft ${
                colIdx !== 0 ? 'holdingsBorderleft' : ''
              }`}
            >
              Total
            </td>
            <td className="subTotalTextCenter">
              {this.formatPercent(subtotalRaw)}
            </td>
          </Fragment>
        );
      });

    // Render by type
    if (fundRows && type === 'dataRow') {
      return (
        <tr key={`row-${idx}`}>
          <Fragment>{buildRow(idx)}</Fragment>
        </tr>
      );
    }
    if (fundRows && type === 'total') {
      return (
        <tr key="row-total">
          <Fragment>{buildSubtotal()}</Fragment>
        </tr>
      );
    }
    if (fundRows && type === 'dataRow2') {
      return (
        <tr key={`row2-${x}`}>
          <Fragment>{buildRow(x)}</Fragment>
        </tr>
      );
    }

    return null;
  }
}

/* ------------------------------ redux wiring ------------------------------ */
function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}

export default connect(mapStateToProps, {})(HoldingsRow);
